import React from "react";
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";

const ContactSection = () => {
  return (
    <>
      {/* Page Title */}





<section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>Contact Us</h1>
    </div>
  </div>
</section>



      {/* Contact Info Section */}
      <section className="container pt-5 pb-5">
        <div className="sec-title text-center mb-5">
          <div className="sub-title woodland-accent">Get in Touch</div>
          <h2 className="woodland-text">Drop a message for any query</h2>
        </div>

        <div className="row contact-info-content">
          
          {/* Phone */}
          <div className="col-lg-4 col-md-6 mb-4">
            <div className="info-item text-center woodland-card">
              <div className="info-icon woodland-icon">
                <FaPhone />
              </div>
              <h3 className="woodland-text">Phone Number</h3>
              <a href="tel:+919175577266" className="darkcolor fw-bold">
                +91 9175577266
              </a>
            </div>
          </div>

          {/* Email */}
          <div className="col-lg-4 col-md-6 mb-4">
            <div className="info-item text-center woodland-card">
              <div className="info-icon woodland-icon">
                <FaEnvelope />
              </div>
              <h3 className="woodland-text">Email</h3>
              <a
                href="mailto:woodlandescape01@gmail.com"
                className="darkcolor fw-bold"
              >
                woodlandescape01@gmail.com
              </a>
            </div>
          </div>

          {/* Address */}
          <div className="col-lg-4 col-md-12 mb-4">
            <div className="info-item text-center woodland-card">
              <div className="info-icon woodland-icon">
                <FaMapMarkerAlt />
              </div>
              <h3 className="woodland-text">Address</h3>
              <p className="darkcolor mb-0 fw-bold">
                Woodland Escape  <br />
                Wadamba, Behind St.Peters School, <br />
                Deolapar, Dist. Nagpur - 441401
              </p>
            </div>
          </div>

        </div>
      </section>

      {/* Map Section */}
      <section className="map-section-two mx-60">
        <div className="auto-container">
          <div className="contact-map">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2931.7265725931243!2d79.37477969999999!3d21.6118876!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bd52d007500bf09%3A0xb5bb075c08a4ad5f!2sWoodland%20Escape!5e1!3m2!1sen!2sin!4v1761904192138!5m2!1sen!2sin"
              width="100%"
              height="450"
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
              title="Woodland Escape Location"
            ></iframe>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactSection;
